import { c as _c } from "react/compiler-runtime";
import { Card, CardContent, CardHeader, CardTitle } from './Card';
import { FlexContainer } from './FlexContainer';
import { InfoGrid } from './InfoGrid';
import { Separator } from './Separator';
import { Skeleton } from './Skeleton';
interface InfoCardSkeletonProps {
  rows?: number;
  columns?: 1 | 2;
  separator?: boolean;
}
export function InfoCardSkeleton(t0) {
  const $ = _c(11);
  const {
    rows: t1,
    columns: t2,
    separator: t3
  } = t0;
  const rows = t1 === undefined ? 6 : t1;
  const columns = t2 === undefined ? 2 : t2;
  const separator = t3 === undefined ? false : t3;
  let t4;
  if ($[0] !== rows) {
    t4 = Array.from({
      length: rows
    }).map(_temp);
    $[0] = rows;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const statRows = t4;
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <CardHeader><CardTitle><Skeleton height={20} width={140} /></CardTitle></CardHeader>;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== separator) {
    t6 = separator && <Separator className="mb-4" />;
    $[3] = separator;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== columns || $[6] !== statRows) {
    t7 = columns === 2 ? <InfoGrid>{statRows}</InfoGrid> : <FlexContainer className="gap-3" direction="column">{statRows}</FlexContainer>;
    $[5] = columns;
    $[6] = statRows;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t6 || $[9] !== t7) {
    t8 = <Card>{t5}<CardContent>{t6}{t7}</CardContent></Card>;
    $[8] = t6;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  return t8;
}
function _temp(_, i) {
  return <FlexContainer className="gap-1" direction="column" key={i}><Skeleton height={12} width={80} /><Skeleton height={16} width={160} /></FlexContainer>;
}